module.exports = __webpack_public_path__ + "img/yellow.35e01c44.png";